module.exports = __webpack_public_path__ + "static/media/Gardener.e5bde276.jpg";